import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Container, Paper, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

const McpAuthorize: React.FC = () => {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [connecting, setConnecting] = useState(false);
  const requestToken = new URLSearchParams(location.search).get('request');
  const authToken = sessionStorage.getItem('authToken');

  useEffect(() => {
    if (!authToken) {
      const returnTo = `${location.pathname}${location.search}`;
      window.location.href = `/login?returnTo=${encodeURIComponent(returnTo)}`;
    }
  }, [authToken, location.pathname, location.search]);

  const authorize = async () => {
    if (!requestToken || !authToken) return;
    setConnecting(true);
    setError(null);
    try {
      const body = await api.approveMcpAuthorization(requestToken);
      window.location.href = body.redirect_url;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not authorize the MCP connection');
      setConnecting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Paper sx={{ width: '100%', p: 4 }}>
        <Typography variant="h4" gutterBottom>Connect Codex</Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Codex is requesting access to manage scenarios and runbooks using your existing
          CaosBlitz roles and tenant permissions.
        </Typography>
        {!requestToken && <Alert severity="error">This authorization link is incomplete.</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button onClick={() => window.close()} disabled={connecting}>Cancel</Button>
          <Button
            variant="contained"
            onClick={authorize}
            disabled={!requestToken || !authToken || connecting}
            startIcon={connecting ? <CircularProgress size={18} /> : undefined}
          >
            Authorize Codex
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default McpAuthorize;
